import { Denied } from 'hatch-components';
import React from 'react';
import DefaultTemplate from 'root/components/templates/Default';
import { HATCH_APP_ROUTE } from 'root/stores/routes/APP_URLS';

import {
  StyledButton,
  StyledError,
  StyledErrorMessage,
  StyledHeader,
  StyledSubHeader,
} from './styles';

const Error = () => {
  return (
    <DefaultTemplate title="Not Found">
      <StyledError>
        <StyledErrorMessage>
          <Denied />
          <StyledHeader>Uh-oh, hold up...</StyledHeader>
          <StyledSubHeader>
            Looks like you don&lsquo;t have permissions to view this page
          </StyledSubHeader>
          <StyledButton
            data-test-id="5589e587-fd24-42df-b37b-43c8fce9fbf5"
            onClick={() => window.location.replace(HATCH_APP_ROUTE)}
            textColor="primary"
            variant="ghost"
          >
            Back to Hatch
          </StyledButton>
        </StyledErrorMessage>
      </StyledError>
    </DefaultTemplate>
  );
};

export default Error;
